import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Share2, Link as LinkIcon, Check } from "lucide-react";
import { toast } from "sonner";

// Condivisione del profilo pubblico tramite l'indirizzo breve canonico /p/{username}.
export function ShareButton({ url, title, shareLabel, hideUrl }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  if (!url) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); toast.success(t("sharex.copied")); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error(t("sharex.copy_failed")); }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    copy();
  };
  return (
    <div className="flex gap-2 items-center flex-wrap" data-testid="share-box">
      <button className="yp-btn yp-btn-outline !py-1.5 !px-3 text-sm flex items-center gap-1" onClick={share} data-testid="share-btn"><Share2 size={16} /> {shareLabel || t("sharex.share")}</button>
      <button className="yp-btn yp-btn-ghost !py-1.5 !px-3 text-sm flex items-center gap-1" onClick={copy} data-testid="copy-link-btn">
        {copied ? <Check size={16} /> : <LinkIcon size={16} />} {t("sharex.copy")}</button>
      {!hideUrl && <a href={url} className="text-xs text-slate-500 underline break-all" data-testid="public-short-url">{url.replace(/^https?:\/\//, "")}</a>}
    </div>);
}
